/**
 * @type {readonly ['ChargebackHandler', 'ChangePrescriber', 'ToggleMessaging', 'ApplyCredit', 'CreateOrder', 'SendMessage', 'AddNote', 'ScoresHistory', 'AwaitingSummary', 'UpdateDoctorDetails', 'UpdateBasicDetails', 'GenerateAccountData', 'VerifyIdentity', 'ManuallyVerifyEmail', 'ManualAuthEmailTools', 'AssignRole', 'DisableAccount', 'MarketingUnsubscribe', 'CandorReviews', 'UploadDocument', 'HealthOverview', 'ApprovePharmacy', 'ApproveSupplier', 'ApproveDoctor', 'TakeOfflineOnline', 'AddToMediRecords', 'SecurityDetails', 'RemoveMFA', 'GoLive', 'OptionalFlag', 'ExportPatientMedicalRecords', 'RESOLVE_CHARGEBACKS', 'TOGGLE_ACCOUNT_LOCK', 'LOADING', 'BlockedPharmacies', 'DefaultPharmacy', 'ViewAllDocuments']}
 *
 * */
export const patientOverviewActions = [
  'ChargebackHandler',
  'ChangePrescriber',
  'ToggleMessaging',
  'ApplyCredit',
  'CreateOrder',
  'SendMessage',
  'AddNote',
  'ScoresHistory',
  'AwaitingSummary',
  'UpdateDoctorDetails',
  'UpdateBasicDetails',
  'GenerateAccountData',
  'VerifyIdentity',
  'ManuallyVerifyEmail',
  'ManualAuthEmailTools',
  'AssignRole',
  'DisableAccount',
  'MarketingUnsubscribe',
  'CandorReviews',
  'UploadDocument',
  'HealthOverview',
  'ApprovePharmacy',
  'ApproveSupplier',
  'ApproveDoctor',
  'TakeOfflineOnline',
  'AddToMediRecords',
  'SecurityDetails',
  'RemoveMFA',
  'GoLive',
  'OptionalFlag',
  'ExportPatientMedicalRecords',
  'RESOLVE_CHARGEBACKS',
  'TOGGLE_ACCOUNT_LOCK',
  'LOADING',
  'BlockedPharmacies',
  'DefaultPharmacy',
  'ViewAllDocuments',
];
